<lib-panel-layout>
  <div class="flex flex-col items-stretch w-full min-w-0 gap-3 xl:items-center">
    <div class="grid grid-cols-2 gap-2 w-full lg:grid-cols-2 sm:grid-cols-4">
      @for (option of layoutOptions; track option.layout) {
        <button
          libButton
          variant="primary"
          size="xs"
          type="button"
          class="w-full gap-1 px-1.5! leading-none"
          [class.is-pressed]="layout === option.layout"
          (click)="onLayoutSelected(option.layout)">
          <mat-icon class="inline-flex! size-4! shrink-0 items-center justify-center text-base! leading-none!">{{
            option.icon
          }}</mat-icon>
          <span class="noselect min-w-0 truncate text-[9px] leading-none">{{ option.labelKey | translate }}</span>
        </button>
      }
    </div>

    @if (isGridLayout) {
      <div class="flex flex-col w-full min-w-0 gap-1.5">
        <lib-number-input
          class="min-w-0"
          [label]="'EDITOR.MERGE.ROWS' | translate"
          [value]="rowCount"
          [min]="1"
          [max]="maxGridDimension"
          (changed)="onRowCountChanged($event)">
        </lib-number-input>
        <lib-number-input
          class="min-w-0"
          [label]="'EDITOR.MERGE.COLUMNS' | translate"
          [value]="columnCount"
          [min]="1"
          [max]="maxGridDimension"
          (changed)="onColumnCountChanged($event)">
        </lib-number-input>
      </div>
    }

    <div class="flex flex-col w-full min-w-0 gap-1.5">
      @if (!isCustomLayout) {
        <lib-number-input
          class="min-w-0"
          [label]="'EDITOR.MERGE.SPACING' | translate"
          [value]="spacing"
          [min]="0"
          [max]="maxSpacing"
          (changed)="onSpacingChanged($event)"
          unit="px">
        </lib-number-input>
      }
      <lib-number-input
        class="min-w-0"
        [label]="'EDITOR.MERGE.BORDER_WIDTH' | translate"
        [value]="borderWidth"
        [min]="0"
        [max]="maxBorderWidth"
        (changed)="onBorderWidthChanged($event)"
        unit="px">
      </lib-number-input>
      <lib-color-picker
        class="min-w-0"
        [label]="'EDITOR.MERGE.BORDER_COLOR' | translate"
        [value]="borderColor"
        (changed)="onBorderColorChanged($event)">
      </lib-color-picker>
    </div>

    <lib-checkbox
      class="min-w-0 lg:w-full"
      [label]="'EDITOR.MERGE.TRANSPARENT_BACKGROUND' | translate"
      [checked]="useTransparentBackground"
      (changed)="onTransparentBackgroundChanged($event)">
    </lib-checkbox>

    <div class="flex flex-col w-full min-w-0 gap-1.5">
      <lib-color-picker
        class="min-w-0"
        [label]="'EDITOR.MERGE.BACKGROUND_COLOR' | translate"
        [value]="backgroundColor"
        [transparent]="useTransparentBackground"
        [displayValue]="useTransparentBackground ? ('EDITOR.MERGE.TRANSPARENT' | translate) : undefined"
        (changed)="onBackgroundColorChanged($event)">
      </lib-color-picker>
    </div>

    @if (imageSize(); as size) {
      <p class="w-full text-center text-[11px] leading-3 text-editor-muted">
        {{ 'EDITOR.MERGE.RESULT_SIZE' | translate: { width: size.width, height: size.height } }}
      </p>
    }
  </div>

  <lib-apply-panel
    panelActions
    class="w-full"
    [applyDisabled]="!canApply"
    (apply)="onApply()"
    (cancelRequested)="onCancel()">
  </lib-apply-panel>
</lib-panel-layout>
